function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ChallengeDashboard", {
  enumerable: true,
  get: function get() {
    return _ChallengeDashboard["default"];
  }
});
exports.Dashboard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useDisableLocaleMessage = require("./useDisableLocaleMessage");
var _components = require("../../components");
var _styles = require("./styles");
var _useUnreadAnnouncement = require("./useUnreadAnnouncement");
var _DefaultDashboard = _interopRequireDefault(require("./DefaultDashboard"));
var _DashboardController = require("./DashboardController");
var _ChallengeDashboard = _interopRequireDefault(require("./ChallengeDashboard"));
var _styles2 = require("../../styles");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var controller = new _DashboardController.DashboardController();
var Dashboard = exports.Dashboard = (0, _react.memo)(function (_ref) {
  var type = _ref.type;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _useDisableLocaleMess = (0, _useDisableLocaleMessage.useDisableLocaleMessage)(),
    disableLocaleMessage = _useDisableLocaleMess.disableLocaleMessage,
    disableLocaleMessageOnRead = _useDisableLocaleMess.disableLocaleMessageOnRead;
  var _useUnreadAnnouncemen = (0, _useUnreadAnnouncement.useUnreadAnnouncement)(),
    announcements = _useUnreadAnnouncemen.announcements,
    onReadAnnouncement = _useUnreadAnnouncemen.readAnnouncement,
    isLoadingAnnouncement = _useUnreadAnnouncemen.isLoading;
  var _controller$useContro = controller.useController(),
    hasChallenge = _controller$useContro.hasChallenge,
    isLoading = _controller$useContro.isLoading;
  var _hasAnnouncement = !isLoadingAnnouncement && !!announcements && announcements.length > 0;
  var _type = type || (hasChallenge ? _types.dashboardType.challenge : _types.dashboardType["default"]);
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.View, {
      style: styles.container,
      children: (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {})
    });
  }
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_components.View, {
      style: [styles.container, !disableLocaleMessage && !_hasAnnouncement && {
        marginBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0
      }],
      children: [!!disableLocaleMessage && (0, _jsxRuntime.jsx)(_components.Announcements, {
        items: [disableLocaleMessage],
        onRead: disableLocaleMessageOnRead,
        testID: 'DisableLocaleMessage'
      }), _hasAnnouncement && (0, _jsxRuntime.jsx)(_components.Announcements, {
        style: [!!disableLocaleMessage && {
          marginTop: spacing.normal
        }],
        items: announcements,
        onRead: onReadAnnouncement
      })]
    }), _type === _types.dashboardType["default"] && (0, _jsxRuntime.jsx)(_DefaultDashboard["default"], {}), _type === _types.dashboardType.challenge && (0, _jsxRuntime.jsx)(_ChallengeDashboard["default"], {})]
  });
});